import React from "react"

const Header = () => {
    return <h1 style={{color: '#eee'}}>Minhas Tarefas</h1>
}
 
export default Header